// extracted by mini-css-extract-plugin
export default {"columnOrientation":"columnOrientation-gZa4m","rowOrientation":"rowOrientation-uC2IO","checkboxesContainer":"checkboxesContainer-si_V7","checkbox":"checkbox-QSyme"};